module.exports = __webpack_public_path__ + "static/media/general-query-grey.b3313cc5.svg";